import React, { useState, useEffect, lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { loader } from "./Utilities/loader.jsx";
import Chatbot from "./Components/chatbot/chatbot.jsx";

function App() {
  // Lifecycle hook - useEffect
  useEffect(() => {
    loader("stop");
  }, []);

  return (
    <div>
      <BrowserRouter>
        <div id="spinner-loader">
          <div className="spinner"></div>
        </div>

        <div>
          <Suspense fallback={<p className="loading"></p>}>
            <Routes>
              {/* Redirect "/" to "/chatbot/chatbot" */}
              <Route path="/" element={<Navigate to="/chatbot/chatbot" replace />} />
              
              {/* Chatbot Route */}
              <Route path="/chatbot/chatbot" element={<Chatbot />} />

              {/* 404 - Page Not Found */}
              <Route path="*" element={<p>404 - Page Not Found</p>} />
            </Routes>
          </Suspense>
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
